import React, { ReactElement } from "react"
import { ExternalIcon, InternalIcon, Link } from "@carrotfertility/carotene-core"
import { FormattedMessage } from "react-intl"
import useFindHelpLink from "./useFindHelpLink"
import { MemberActions } from "#/services/memberActionTracking/memberActions"
import { useMemberActionTracking } from "#/services/memberActionTracking/useMemberActionTracking"
import { useSDoHModal } from "./SDoHModalContext"

export const SDoHFindHelpLink = (): ReactElement => {
  const { findHelpLink } = useFindHelpLink()
  const memberActionMutation = useMemberActionTracking()

  return (
    <Link
      href={findHelpLink}
      target={"_blank"}
      onClick={() =>
        memberActionMutation.mutate({
          memberActionTaken: MemberActions.SDOH_FINDHELP_LINK_CLICKED
        })
      }
      sx={linkStyles}
      color={"primary"}
      endIcon={<ExternalIcon fontSize="small" color="primary" />}
      component={"a"}
    >
      <FormattedMessage defaultMessage="Search for resources" />
    </Link>
  )
}

export const SDoHQuestionLink = (): ReactElement => {
  const { openModal } = useSDoHModal()

  return (
    <Link
      sx={linkStyles}
      color={"primary"}
      endIcon={<InternalIcon fontSize="small" color="primary" />}
      component={"button"}
      onClick={openModal}
    >
      <FormattedMessage defaultMessage="Answer question" />
    </Link>
  )
}

const linkStyles = {
  display: "flex",
  alignItems: "center",
  textDecorationLine: "none",
  cursor: "pointer",
  "&:hover": {
    textDecorationLine: "underline",
    textDecorationColor: "primary"
  }
}
